import { StyleSheet } from 'react-native';

import { initialWindowMetrics } from 'react-native-safe-area-context';

import { whiteTransparent } from 'utils/colors';

const styles = StyleSheet.create({
    root: {
        width: '100%',
        borderColor: whiteTransparent(0.1),
        borderBottomWidth: 1,
    },
    rootWithInsets: {
        marginTop: initialWindowMetrics?.insets.top,
    },
});

export default styles;
